import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { Utils } from "src/app/common/utils";
import { Location } from '@angular/common';
import { FormBuilder, Validators, FormControl, FormArray, FormGroup } from "@angular/forms";
import { ConfirmedValidator } from "src/app/common/passwordValidator";
import { specialityNames } from "src/app/models/specialityNames";
import { ExcelService } from "src/app/service/excelDownload/excel.service";
import moment from "moment";
import { environment } from 'src/environments/environment';
// import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-superadmin-phy-detail",
  templateUrl: "./superadmin-phy-detail.component.html",
  styleUrls: ["./superadmin-phy-detail.component.scss"],
})
export class SuperadminPhyDetailComponent implements OnInit {
  @ViewChild('PDFModal', { static: true } as any) PDFModal: TemplateRef<any>;
  phydashCurrentTab: string = "personalInformation";
  phydashlistOfTabs: string[] = [
    "personalInformation",
    "bankAccount",
    "appointment",
  ];
  formsSuperadmin = {
    bankAccount: null,
  };
  termsConditions: boolean = false;
  upcoming: boolean = true;
  modalRef: NgbModalRef;
  //specialitiesList: any = [];
  specialitiesList: specialityNames[];
  appointmentType: string;
  allAppointmentData: any;
  u_id: any;
  physician: any;
  pastAppointmentData: any;
  upcomingAppointmentData: any;
  dateFormat = Utils.DATE_FORMAT;
  enableEdit: boolean = false;
  phyBankAccType: string[] = [
    Utils.ACCOUNT_TYPE.SAVINGS,
    Utils.ACCOUNT_TYPE.CURRENT,
  ];
  phyQualification: string = "";


  // variable Declaration for PDF
  pdfSrc: any;
  aptid: any;
  room_id: any;
  appointment: any;
  pdfSrc1: any;

  constructor(
    private service: VproService,
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private phyService: VproService,
    private utils: Utils,
    private location: Location,
    private _formBuilder: FormBuilder,
    private excelService: ExcelService
  ) {
    this.u_id = this.route.snapshot.params["id"];
    this.formsSuperadmin.bankAccount = this._formBuilder.group({
      /* bank_name: ['', [Validators.required, Validators.pattern(Utils.nameRegex)]],
      city: ['', Validators.required], */
      ifsc_code: ['', [Validators.required, Validators.pattern(Utils.ifscRegex)]],
      beneficiary_name: ['', [Validators.required, Validators.pattern(Utils.nameRegex)]],
      account_type: ['', [Validators.required, Validators.pattern(Utils.alphaRegex)]],
      account_number: ['', [Validators.required, Validators.pattern(Utils.accountNumberRegex)]],
      confirm_account_number: ['', [Validators.required, Validators.pattern(Utils.accountNumberRegex),]]
    },
      {
        validator: ConfirmedValidator('account_number', 'confirm_account_number')
      });
  }

  ngOnInit() {
    this.getSpeciality();
    this.getPhysicianById();
    /*this.route.params.subscribe((routeParams) => {
      this.getPhysicianById();
    });*/
  }
  public phydashAssignTab(tabName: string): void {
    this.phydashCurrentTab = tabName;
    if (this.phydashCurrentTab === "appointment") {
      this.upcoming = true;
    }
  }

  /** next tabs based on next click by user */
  public phydashNextTab(): void {
    let index = this.phydashlistOfTabs.indexOf(this.phydashCurrentTab);
    this.phydashCurrentTab = this.phydashlistOfTabs[index + 1];
  }
  /** get previous tabname and info */
  public phydashPreviousTab(): void {
    let index = this.phydashlistOfTabs.indexOf(this.phydashCurrentTab);
    this.phydashCurrentTab = this.phydashlistOfTabs[index - 1];
  }


  showToast(type, title) {
    Toast.fire({
      type: type,
      title:
        title
    });
  }

  getPastAppointment() {
    let data = {};
    this.appointmentType = Utils.PAST_APPOINTMENT;
    this.upcomingAppointmentData = null;
    this.spinner.show();
    this.phyService
      .getAppointmentDetails(
        data,
        `type=${Utils.PAST_APPOINTMENT}&drid=${this.u_id}`
      )
      .subscribe((result) => {
        this.spinner.hide();

        this.pastAppointmentData = result;
        if (this.pastAppointmentData["totalCount"] === 0) {
          this.pastAppointmentData = null;
          this.showToast('error', "No Completed Appointments Found");
        }
        else {

          this.pastAppointmentData["result"].forEach((aptime) => {
            if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
          });

        }
      }, error => {
        this.spinner.hide();
        this.showToast('error', "No Completed Appointments Found");
      });
  }

  getUpcomingAppointment() {
    let data = {};
    this.appointmentType = Utils.UPCOMING_APPOINTMENT;
    this.pastAppointmentData = null;
    this.spinner.show();
    this.phyService
      .getAppointmentDetails(
        data,
        `type=${Utils.UPCOMING_APPOINTMENT}&drid=${this.u_id}`
      )
      .subscribe((result) => {
        this.spinner.hide();
        this.upcomingAppointmentData = result;

        if (this.upcomingAppointmentData["result"].length > 0) {
          this.upcomingAppointmentData["result"].forEach((aptime) => {
            if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
          });
        }

      }, error => {
        this.spinner.hide();
        this.showToast('error', "No Upcoming Appointments Found");
      });
  }

  getAllAppointment() {
    let data = {};
    this.appointmentType = Utils.ALL_APPOINTMENT
    this.allAppointmentData = null;
    this.spinner.show();
    this.phyService
      .getAppointmentDetails(
        data,
        `type=${Utils.ALL_APPOINTMENT}&drid=${this.u_id}`
      )
      .subscribe((result) => {
        this.spinner.hide();
        this.allAppointmentData = result;
        if (this.allAppointmentData["result"].length > 0) {
          this.allAppointmentData["result"].forEach((aptime) => {
            if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
          });
        }

      }, error => {
        this.spinner.hide();
        this.showToast('error', "No Appointments Found");
      });
  }

  getPhysicianById() {
    this.spinner.show();
    this.phyService
      //.getPhysicianById(this.u_id, "?fields=physician_bank_details,consult_fee,superadmin")
      .getPhysicianById(this.u_id, "?fields=physician_bank_details,consult_fee")
      .subscribe(
        (result) => {
          console.log("result", result);
          this.spinner.hide();
          this.physician = result;
          if (this.physician && this.physician.physician_qualification) {
            this.phyQualification = this.getQualification();
          }
          this.formsSuperadmin.bankAccount.disable();
          if (this.physician && this.physician.physician_bank_details) {
            this.termsConditions = true;
            this.formsSuperadmin.bankAccount.patchValue({
              ifsc_code: this.physician.physician_bank_details.ifsc_code,
              account_type: this.physician.physician_bank_details.account_type.toLowerCase(),
              beneficiary_name: this.physician.physician_bank_details.beneficiary_name,
              account_number: this.physician.physician_bank_details.account_number,
              confirm_account_number: "",

            });

            //this.formsSuperadmin.bankAccount.patchValue(this.physician.physician_bank_details);
            //this.formsSuperadmin.bankAccount.disable();
          }
          const uid_val = result.u_id
          this.getAppointment(uid_val);

          console.log("result.uid", result.u_id)
        },
        (error) => {
          this.spinner.hide();
          let message;
          if (
            error &&
            error.error &&
            error.error.message &&
            error.error.message.message
          ) {
            message = error.error.message.message;
          } else message = "Something went wrong. Couldn't update profile.";
          this.showToast('error', message);
        }
      );

  }

  enableForm() {
    this.termsConditions = false;
    this.enableEdit = true;
    this.formsSuperadmin.bankAccount.enable();
  }

  saveBankDetails() {
    let data: any;

    if (this.physician && this.physician.physician_bank_details) {
      data = { ...this.physician };
      data['physician_bank_details'] = this.formsSuperadmin.bankAccount.value;
      if (data && data.physician_bank_details && data.physician_bank_details.confirm_account_number) {
        delete data.physician_bank_details.confirm_account_number;
      }
    }
  }

  getSpeciality() {
    this.phyService.getSpecialitiesList().subscribe((result) => {
      this.specialitiesList = result;
    }, (error) => {
      this.spinner.hide();
    });
  }

  getPhysicianSpecialities(physician_speciality): any {
    let specialities = [];
    if (physician_speciality) {
      if (this.specialitiesList) {
        physician_speciality.forEach(element => {
          let sp = this.specialitiesList.find(s => s.id == element.speciality_id)
          specialities.push(`${sp.name} - ${element.no_of_years}Years`)
        });
        return specialities.join(', ');
      }
      else {
        return "Not Available";
      }
    }
    else {
      return "Not Available";
    }

  }

  getQualification(): string {
    let qualifications = [];
    this.physician.physician_qualification.forEach(element => {
      qualifications.push(element.qualification);
    });
    return qualifications.join(', ');

  }

  exportAsXLSX() {
    let excelPhyApts: any = [];
    let aptDataForExcel: any = [];
    let excelFileName: string = "";
    let excelSheetName: string = "";
    let personalInfo: any = [];

    if (this.pastAppointmentData) {
      excelFileName = (this.physician.first_name + " " + this.physician.last_name) + "_" + this.physician.u_id.toString() + "_PastAppointments";
      excelSheetName = "PastAppointments";
      aptDataForExcel = { ...this.pastAppointmentData };
    }

    if (this.upcomingAppointmentData) {
      excelFileName = (this.physician.first_name + " " + this.physician.last_name) + "_" + this.physician.u_id.toString() + "_UpcomingAppointments";
      excelSheetName = "UpcomingAppointments";
      aptDataForExcel = { ...this.upcomingAppointmentData };
    }
    if (this.allAppointmentData) {
      excelFileName = (this.physician.first_name + " " + this.physician.last_name) + "_" + this.physician.u_id.toString() + "_AllAppointments";
      excelSheetName = "AllAppointments";
      aptDataForExcel = { ...this.allAppointmentData };
    }

    /* Include personal Information in excel sheet */

    if (this.physician) {
      personalInfo.push({
        "NAME": this.physician.first_name + " " + this.physician.last_name,
        "QUALIFICATION": this.phyQualification,
        "SPECIALIZATION": this.getPhysicianSpecialities(this.physician.physician_speciality),
        "CONSULTATION FEE": this.physician.consult_fee,
        "FOLLOW-UP FEE": this.physician.physician_consultfee[0].followup_fee,
        "EMAIL ID": this.physician.email_id,
        "CONTACT NO": this.physician.contact_no
      });
    }

    if (aptDataForExcel["result"]) {
      aptDataForExcel["result"].forEach(element => {
        excelPhyApts.push({
          "APT ID": element.aptid === null ? "Not Available" : element.aptid,
          "APT DATE": element.apdate === null ? "Not Available" : moment(element.apdate, 'YYYY-MM-DD').format('DD-MMM-YYYY'),
          "APT TIME": element.aptime === null ? "Not Available" : element.aptime,
          "PATIENT NAME": ((element.first_name === null ? "" : element.first_name) + " " + (element.last_name === null ? "" : element.last_name)),
          "APT TYPE": element.apttype === null ? "Not Available" : element.apttype.replace('_', ' ').toUpperCase(),
          "STATUS": element.schedule_stat === null ? "Not Available" : element.schedule_stat.replace('_', ' ').toUpperCase()
        });
      });
      this.excelService.exportAsExcelFile(personalInfo, excelPhyApts, excelFileName, excelSheetName);
    }

  }



  // Preview document fetch function
  async previewDocument(doc: any) {
    if (doc && doc.key && doc.key.length > 0) {
      let uri = environment.content_base_url + "/" + doc.key;
      if (Utils.allowedImageFormats.includes(doc.key.split('.').pop())) {
        Swal.fire({
          imageUrl: uri,
          showConfirmButton: false,
          showCloseButton: true,
        })
      } else {
        this.pdfSrc1 = doc;
        const files = { name: doc.name, type: doc.type };
        this.pdfSrc = uri;
        this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });
      }
    }
  }

  // Close model Function
  closeModal() {
    this.modal.dismissAll();
  }


  // Download document
  async downloadDocument(doc) {
    const u_ids = doc.u_id.toString();
    const email = doc.email;
    const file = { name: doc.name, type: doc.type };
    this.service.downloadFile({
      u_id: u_ids, email: email,
      file: { name: file.name, type: file.type }
    }, file).subscribe((result) => {
      window.location.href = result.signedUrl;
    }, (error) => {
      this.spinner.hide();
    });
  }


  // Appointment Detail Get Function
  getAppointment(uid) {
    this.spinner.show();
    this.service.getAppointmentDetails(
      {
        u_id: uid, fields: ["doc_documents"]
      }
    ).subscribe(res => {
      this.spinner.hide();
      this.appointment = res;
      if (this.appointment && this.appointment.length > 0) {
        this.appointment.forEach((element, index) => {
          if (element.key && element.key.length > 0 && element.key.includes('/')) {
            let file = element.key.split('/');
            if (file && file.length > 0)
              this.appointment[index]['name'] = file.pop();
          }
        });
      }
    }, error => {
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    });
  }
  getback() {
    this.location.back();
  }
}
